export const prop = 'objectImpacted';

export const config = (labels) => ({
	id: 'objectImpactedColumn',
	label: labels.objectImpacted,
	propName: prop,
	width: 'minmax(20rem, 3fr)',
	sortBy: prop
});
